import { removeFeed, updateContextProperty } from "orion-components/ContextualData/Actions";
import { attachmentService, facilityService } from "client-app-core";
import { getTranslation } from "orion-components/i18n";

export function removeFloorPlanCameraSub(contextId, subscriptionId) {
	return dispatch => {
		dispatch(removeFeed(contextId, subscriptionId));
	};
}

export function removeFloorPlanDevicesSub(contextId, subscriptionId) {
	return dispatch => {
		dispatch(removeFeed(contextId, subscriptionId));
	};
}

export const attachFilesToFacility = (facilityId, entityType, files) => {
	return dispatch => {
		dispatch(updateContextProperty(facilityId, "uploadError", ""));
		attachmentService.uploadFiles(facilityId, "facility", files, (err, result) => {
			if (err) {
				console.log(err, result);
				switch (err.response.status) {
					case 413:
						dispatch(
							updateContextProperty(
								facilityId,
								"uploadError",
								getTranslation(
									"global.sharedActions.fileUploadFailed",
									undefined,
									getTranslation("global.sharedActions.uploadError.maxFileSizeExceeded")
								)
							)
						);
						break;
					default:
						dispatch(
							updateContextProperty(
								facilityId,
								"uploadError",
								getTranslation(
									"global.sharedActions.fileUploadFailed",
									undefined,
									getTranslation("global.sharedActions.uploadError.generic")
								)
							)
						);
						break;
				}
			}
		});
	};
};

export const deleteFacility = (facilityId, callback) => {
	facilityService.delete(facilityId, (err, result) => {
		if (err) {
			console.log(err, result);
		} else if (result) {
			if (callback) callback();
		}
	});
};
